import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';
import { SIZE_GRID } from '@gate31/uikit/common/components/warehous/constants';
import { City, Point, WarehouseResponse, WarehouseTransformData } from '@gate31/types/warehouse';
import { Gate31ApiV2 } from '@gate31/core/src/api/gate31-api';

class WarehouseProductError extends Error {
    name = 'WarehouseProductError'
}

export class WarehouseProduct extends BaseJs {
    static readonly cn = new BaseJs.BuildCn('WarehouseProduct');
    static SIZE_GRID = SIZE_GRID;

    protected constructor(template: keyof LiquidTemplates) {
        super(template);
    }

    getStock(productId: string | number) {
        return Gate31ApiV2.getWarehouseStock(String(productId))
            .then(result => {
                if (result) return result;

                throw new WarehouseProductError('unexpected query result');
            })
            .catch(e => {
                throw new WarehouseProductError(e);
            });
    }

    transformStockData(obj: WarehouseResponse): Array<WarehouseTransformData> {
        const data = JSON.parse(JSON.stringify(obj));

        return Object.entries<City[]>(data.cities).map(item => {
            const [ cityKey, cityValue ] = item;

            const pointList: Point[] = cityValue.map(point => {
                let sizeList = [];

                if (Array.isArray(data.sizes)) {
                    sizeList = WarehouseProduct.SIZE_GRID
                        .map(sizeName => {
                            if (data.sizes.includes(sizeName)) {
                                const available = Boolean(data.stores[point] && data.stores[point][sizeName]);

                                return {
                                    name: sizeName,
                                    available
                                };
                            }
                        })
                        .filter(Boolean);
                } else {
                    sizeList = WarehouseProduct.SIZE_GRID
                        .map(sizeName => {
                            if (data.stores[point] && data.stores[point][sizeName]) {
                                return {
                                    name: sizeName,
                                    available: true
                                };
                            }
                        })
                        .filter(Boolean);
                }

                return {
                    link: point,
                    name: data.nameStore[point] as string,
                    phone: data.phoneStore[point] as string,
                    sizes: sizeList as { name: string; available: boolean }[]
                };
            });

            return {
                name: data.nameCity[cityKey],
                link: cityKey,
                points: pointList
            };
        });
    }
}
